import { Box, Typography, useTheme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React from 'react';

const useStyles = makeStyles()((theme) => ({
  footerItem: { 
    marginLeft: theme.spacing(2.5),
    marginRight: theme.spacing(2.5),
    [theme.breakpoints.down('sm')]: {
      marginLeft: theme.spacing(2.5),
      marginRight: 0,
    }
  },
  footerLink: {
    textDecoration: 'none',
    fontWeight: 'lighter',
    '&:hover, &:visited': { color: theme.palette.text.primary },
  },
  leftItem: {
    marginRight: 'auto',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      marginRight: 0,
    }
  },
  rightItem: {
    marginLeft: 'auto',
    [theme.breakpoints.down('sm')]: {
      position: 'absolute',
      right: theme.spacing(2.5),
    }
  },
  centerItem: {
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  mobileOnly: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'block'
    }
  },
  desktopOnly: {
    display: 'block',
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  }
}));

export default function Footer() {
  const theme = useTheme();
  const { classes } = useStyles();
  return (
    <Box
      position="fixed"
      bottom={0}
      left={0}
      bgcolor="rgb(230,230,230)"
      height={theme.spacing(4)}
      width="100vw"
      display="flex"
      alignItems="center"
    >
      {/* Desktop - left item */}
      <Typography variant="body2" color="textPrimary" className={`${classes.footerItem} ${classes.leftItem} ${classes.desktopOnly}`}>
        <a href="/user-agreement" className={classes.footerLink}>
          Пользовательское соглашение
        </a>
      </Typography>

      {/* Mobile - left items */}
      <Box className={`${classes.leftItem} ${classes.mobileOnly}`}>
        <Typography variant="body2" color="textPrimary" className={classes.footerItem}>
          <a href="/privacy-policy" className={classes.footerLink}>
            Политика конфиденциальности
          </a>
        </Typography>
        <Typography variant="body2" color="textPrimary" className={classes.footerItem}>
          <a href="/user-agreement" className={classes.footerLink}>
            Пользовательское соглашение
          </a>
        </Typography>
      </Box>

      {/* Center item (desktop only) */}
      <Typography variant="body2" color="textPrimary" className={`${classes.footerItem} ${classes.centerItem}`}>
        <a href="/privacy-policy" className={classes.footerLink}>
          Политика конфиденциальности
        </a>
      </Typography>

      {/* Right item */}
      <Typography variant="body2" color="textPrimary" className={`${classes.footerItem} ${classes.rightItem}`}>
        <a href="/payments-info" className={classes.footerLink}>
          Об оплате
        </a>
      </Typography>
    </Box>
  );
}